var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[(_vm.accessing)?_c('p',[_vm._v("Proberen toegang te verkrijgen...")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_c('p',{staticClass:"logout",on:{"click":_vm.logout}},[_vm._v("Log uit")])])
}
var staticRenderFns = []

export { render, staticRenderFns }